export default {
    requiredPlugins: ['i18n'],

    defaultConfig: {
        loadMixin: true,
    },

    install(Vue, {router, store, loadMixin}) {
        Vue.component('form-element', require('../components/FormElement').default);
        Vue.component('submit-button', require('../components/SubmitButton').default);

        if (loadMixin) {
            Vue.mixin(require('../mixins/formMixin').install({router, store}));
        }
    },
};